import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type CreateWorkspaceMutationVariables = Types.Exact<{
  input: Types.CreateWorkspaceInput;
}>;


export type CreateWorkspaceMutation = { __typename?: 'Mutation', createWorkspace?: { __typename?: 'CreateWorkspacePayload', workspace?: { __typename?: 'Workspace', id: string, daysBeforeAssetAutoDeletion?: number | null, name: string, images?: { __typename?: 'Images', image128?: string | null, original?: string | null } | null } | null } | null };


export const CreateWorkspace = /*#__PURE__*/ gql`
    mutation CreateWorkspace($input: CreateWorkspaceInput!) {
  createWorkspace(input: $input) {
    workspace {
      id
      daysBeforeAssetAutoDeletion
      images {
        image128
        original
      }
      name
    }
  }
}
    ` as unknown as DocumentNode<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>;

          

          export const useCreateWorkspaceMutation = (options?:MutationHookOptions<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>) => useMutation(CreateWorkspace, options);
          

          export type CreateWorkspaceMutationOptions = MutationHookOptions<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>;

          

          export type CreateWorkspaceMutationResult = ReturnType<typeof useCreateWorkspaceMutation>[1];

          
